import { Box, Button, Grid, TextField } from "@material-ui/core";
import axios from "axios";
import { Field, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import {
  LoadCanvasTemplate,
  loadCaptchaEnginge,
  validateCaptcha,
} from "react-simple-captcha";
import Stepper from "react-stepper-horizontal";
import FinalStep from "../FinalStep/FinalStep";

const Step4 = (props) => {
  const { values } = useFormikContext();
  const [uploadFiles, setUploadFiles] = useState([]);
  const [error, setError] = useState("");
  const [created, setCreated] = useState(false);

  useEffect(() => {
    loadCaptchaEnginge(6);
    let files = [];
    // On récupere les uploads des logos stocké dans dans le context
    if (values.appLogo.length > 0) {
      files.push({ file: values.appLogo[0], type: 1 });
    }
    for (let i = 0; i < props.formState.sponsorLogos.length; i++) {
      if (props.formState.sponsorLogos.length > 0) {
        files.push({ file: props.formState.sponsorLogos[i], type: 21 });
      }
    }
    for (let i = 0; i < props.formState.partnerLogos.length; i++) {
      if (props.formState.partnerLogos.length > 0) {
        files.push({ file: props.formState.partnerLogos[i], type: 31 });
      }
    }
    props.setFormState({ ...props.formState, ...values });
    setUploadFiles((uploadFiles) => files);
  }, []);

  const handleChange = (key, value) => {
    props.setFormState({ ...props.formState, [key]: value });
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const stepValidated = () => {
    return (props.formState.email.length > 0 ||
      props.formState.phone.length > 0) &&
      !props.errors.email &&
      !props.errors.phone
      ? true
      : false;
  };

  const submitForm = async (e) => {
    // Transfomation des images en base64
    let upload = {
      files: [],
    };
    for (let i = 0; i < uploadFiles.length; i += 1) {
      let base_strings = uploadFiles.map((el) => {
        return getBase64(el.file);
      });
      const base64 = await Promise.all(base_strings);
      upload.files.push({ file: base64[i], type: uploadFiles[i].type });
    }

    // Transformation des Trace GPX en base64
    let gpxTrace = {
      gpxFiles: [],
    };
    for (let i = 0; i < values.gpxTrace.length; i++) {
      if (values.gpxTrace[i].file[i]) {
        gpxTrace.gpxFiles.push({
          name: values.gpxTrace[i].name,
          file: values.gpxTrace[i].file[i],
          traceName: values.gpxTrace[i].traceName,
          base64: "",
        });
        let base_strings2 = gpxTrace.gpxFiles.map((el) => {
          return getBase64(el.file[0]);
        });
        const gpx64 = await Promise.all(base_strings2);
        gpxTrace.gpxFiles[i].base64 = gpx64[i];
      }
    }
    // Stockage des images et traces GPX convertis dans un nouvel objet
    const formInfo = { ...props.formState, ...upload, ...gpxTrace };
    // Supression des doublons
    delete formInfo.gpxTrace;
    delete formInfo.partnerLogos;
    delete formInfo.sponsorLogos;
    delete formInfo.appLogo;
    console.log(formInfo);
    let user_captcha_value =
      document.getElementById("user_captcha_input").value;

    if (validateCaptcha(user_captcha_value) == true) {
      axios
        .post(process.env.REACT_APP_API_URL + "/appCreation/create", formInfo, {
          headers: {
            appId: "434364515444337a774f2b2b30495268414f7133446e6974",
            appPassword: "4768452f48743052",
            appname: "dashboard",
          },
        })
        .then((res) => {
          props.setFieldValue("appID", res.data.appID);
          setCreated(true);
        })
        .catch((err) => {
          console.log(err);
          setError("Erreur lors de l'envoi du formulaire");
        });
    } else {
      setError("Captcha Incorrect");
    }
  };

  return (
    <div>
      {created === false ? (
        <div>
          <Stepper
            titleFontSize={12}
            steps={[
              { title: "Application" },
              { title: "Inscription" },
              { title: "Course" },
            ]}
            activeStep={2}
          />
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <h3>
                D'ici quelques instants vous obtiendrez votre application test
              </h3>
              <i>
                L'application test ne peut être installée uniquement sur un
                smartphone Android (pas d'Iphone) et n'est effective que sur une
                durée de 15 jours.
              </i>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                onChange={(e) => {
                  props.setFormState({
                    ...props.formState,
                    name: e.target.value,
                  });
                }}
                value={props.formState.name}
                id="name"
                type="text"
                label="Nom Prénom"
              />
            </Grid>
            <Grid item xs={12}>
              <p>
                <strong>
                  Pour obtenir le lien de l'application par mail, merci de
                  remplir ce champs.
                </strong>
                <br />
                <strong>ATTENTION</strong> : il faut que vous puissiez ouvrir
                votre boite mail sur votre smartphone Android. <br />
                <span>Pensez à vérifier vos SPAMS</span>
              </p>

              <Grid item xs={12} md={6}>
                <Field name="email">
                  {({ field, form, meta }) => (
                    <TextField
                      error={meta.touched && meta.error ? true : false}
                      helperText={meta.touched && meta.error ? meta.error : ""}
                      onChange={(e) =>
                        handleChange(e.target.name, e.target.value)
                      }
                      id="email"
                      type="text"
                      label="Email"
                      {...field}
                      onKeyUp={(e) =>
                        handleChange(e.target.name, e.target.value)
                      }
                    />
                  )}
                </Field>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <p>
                <strong>
                  Pour obtenir le lien de l'application par SMS, merci de
                  remplir ce champs.
                </strong>
              </p>
              <Field name="phone">
                {({ field, form, meta }) => (
                  <TextField
                    error={meta.touched && meta.error ? true : false}
                    helperText={meta.touched && meta.error ? meta.error : ""}
                    onChange={(e) =>
                      handleChange(e.target.name, e.target.value)
                    }
                    id="phone"
                    type="text"
                    label="Téléphone"
                    {...field}
                    onKeyUp={(e) => handleChange(e.target.name, e.target.value)}
                  />
                )}
              </Field>
            </Grid>
            <Grid
              xs={12}
              md={6}
              style={{ marginLeft: "10px", marginTop: "20px" }}
            >
              <Grid>
                <LoadCanvasTemplate />
              </Grid>
              <Grid>
                <TextField
                  placeholder="Insérez le captcha"
                  id="user_captcha_input"
                  name="user_captcha_input"
                  type="text"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
            <Grid container justify="flex-end">
              <Box my={2}>
                {props.hasPrev() && (
                  <Button
                    className="bottom-button"
                    size="small"
                    onClick={props.prev}
                    variant="outlined"
                    color="primary"
                  >
                    Précédent
                  </Button>
                )}
                {props.hasNext() && (
                  <Button
                    disabled={!stepValidated()}
                    className="bottom-button"
                    size="small"
                    onClick={submitForm}
                    variant="contained"
                    color="primary"
                  >
                    Valider
                  </Button>
                )}
              </Box>
              <Grid xs={12} style={{ textAlign: "right" }}>
                <p style={{ color: "red" }}>{error}</p>
              </Grid>
            </Grid>
            <i style={{ opacity: "0.6", fontSize: "12px" }}>
              * Champ Obligatoire
            </i>
          </Grid>
        </div>
      ) : (
        <FinalStep jump={props.jump} />
      )}
    </div>
  );
};

export default Step4;
